export type BenchmarkKey = 'speaking' | 'writing' | 'reading' | 'listening';

export const BENCHMARK_KEYS: readonly BenchmarkKey[] = ['speaking', 'writing', 'reading', 'listening'];

// Reading and Listening are hidden everywhere in monitoring for now; the
// server still sends them.
export const SHOWN_BENCHMARK_KEYS: readonly BenchmarkKey[] = ['speaking', 'writing'];

export type CellState = 'scored' | 'toScore' | 'inProgress' | 'notStarted' | 'off' | 'notAssigned';

export type ScoredBy = 'teachers' | 'flashlight' | 'auto';

export interface MonitoringCounts {
  scored: number;
  toScore: number;
  inProgress: number;
  notStarted: number;
  closedInProgress?: number;
  closedNotStarted?: number;
  base: number;
}

export interface MonitoringBenchmark {
  key: BenchmarkKey;
  label: string;
  scoredBy: ScoredBy;
  counts: MonitoringCounts;
}

export interface MonitoringRef {
  id: string;
  name: string;
}

export interface MonitoringGroup {
  ref: MonitoringRef;
  students: number;
  teachers?: number;
  benchmarks: MonitoringBenchmark[];
}

export interface MonitoringCell {
  key: BenchmarkKey;
  state: CellState;
  step?: string;
  submittedAt?: string;
  scoredByFlashlight?: boolean;
  closed?: boolean;
}

export interface MonitoringStudent {
  id: string;
  name: string;
  grade: string;
  cells: MonitoringCell[];
}

export interface MonitoringWindow {
  type: string;
  label: string;
  state: 'open' | 'closed';
  startAt: string;
  closeAt: string;
  flashlightScored: boolean;
}

export interface MonitoringUpcoming {
  type: string;
  label: string;
  startAt: string;
}

export interface MonitoringTeacher {
  id: string;
  name: string;
  firstName: string;
  email: string;
}

export type MonitoringLevel = 'district' | 'school' | 'teacher';

export interface BenchmarkMonitoring {
  scope: 'district' | 'school';
  level: MonitoringLevel;
  districtName: string;
  schoolYear: string;
  window: MonitoringWindow | null;
  upNext: MonitoringUpcoming[];
  school?: MonitoringRef;
  teacher?: MonitoringTeacher;
  students: number;
  benchmarks: MonitoringBenchmark[];
  schools?: MonitoringGroup[];
  teachers?: MonitoringGroup[];
  studentRows?: MonitoringStudent[];
  contactEmails: string[];
  refreshedAt?: string;
}
